// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sso-divider[data-v-1262a83f]{display:flex;align-items:center;text-align:center;color:#999;font-size:13px;margin:2rem auto 2.5rem auto;max-width:550px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
